module.exports = __webpack_public_path__ + "media/img/fallback/logo_image_item_file_default-1eb94bd83f0ea09a4ef00b263e991930.png";